// ForgotPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Styles/Forgot.css';
const RecuperarPwd = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el correo de recuperación
    console.log('Email enviado a:', email);
    navigate('/login'); // Redirigir a la página de inicio de sesión tras enviar el correo
  };

  return (
    <div className="container">
      <h2 className="my-4 text-center">Recuperar Contraseña</h2>
      <div className="row justify-content-center">
        <div className="col-md-6">
          <form onSubmit={handleSubmit} className="border p-4 rounded shadow">
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Correo Electrónico</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100">Enviar</button>
          </form>
          <div className="text-center mt-3">
            <a href="/login">Volver a Iniciar Sesión</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export { RecuperarPwd };
